module.exports = ".stage-card-header {\n  font-size: 0.8rem;\n  background: white;\n  /* border-bottom: 0px; */ }\n\n.stage-card-body {\n  font-size: 0.6rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/title-preview/stage-preview/stage-preview.component.scss
// module id = ./src/app/shared/title-preview/stage-preview/stage-preview.component.scss
// module chunks = main